module.exports = __webpack_public_path__ + "img/18-full-sm.fd3e2624.jpg";